import { asyncActionFactory } from '@Utils/Redux/asyncAction';

import { resultsConfig } from '@Constants/Results';
import { tgitems, SORT_BY_SIMILARITY_FIELD } from '@Constants';

import {
  keyForSortingProperties as keyForSortingPropertiesSelector,
  baseParamsForSortingProperties as baseParamsForSortingPropertiesSelector,
} from './SortingPropertiesSelectors';
import { saveSortingPropertiesType } from './SortingPropertiesConstants';

import * as service from './SortingPropertiesService';

export function saveSortingProperties(key, data, similarityMol) {
  return {
    type: saveSortingPropertiesType,
    payload: {
      key,
      data,
      similarityMol,
    },
  };
}

export const fetchSortingPropertiesSpec = {
  getKey: () => keyForSortingPropertiesSelector,
  action: (similarityMol) => async (dispatch, getState) => {
    const state = getState();
    const baseParamsForSortingProperties = baseParamsForSortingPropertiesSelector(state);
    const key = keyForSortingPropertiesSelector(state);

    if (!Object.keys(baseParamsForSortingProperties).every((paramKey) => !!baseParamsForSortingProperties[paramKey])) {
      Logger.info('Fetch sorting properties called with invalid state params');
      return;
    }

    if (baseParamsForSortingProperties.context === tgitems) {
      dispatch(saveSortingProperties(key, [resultsConfig.ORDER_TYPES.asc, resultsConfig.ORDER_TYPES.desc]));

      return;
    }

    const result = await service.fetchSortingProperties({ ...baseParamsForSortingProperties, similarityMol });
    let similarityMolToSave = null;
    if (result.some((so) => so.value === SORT_BY_SIMILARITY_FIELD)) {
      similarityMolToSave = similarityMol; // similarity may be not supported by BE
    }
    dispatch(saveSortingProperties(key, result, similarityMolToSave));
  },
};
export const fetchSortingProperties = asyncActionFactory(fetchSortingPropertiesSpec);
